// src/router/index.js
import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'
import { hasPathPermission } from '@/config/permissions'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this,location).catch(error=>error)
}

const router = new Router({
  mode: 'hash',
  routes: [
     // 登录路由
     {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { roles: ['*'] }
    },
    // 过渡页面路由
     // 模块选择页面
     {
      path: '/',
      redirect: '/module-selection'
    },
     {
      name: 'ModuleSelection',
      path: '/module-selection',
      component: () => import('@/views/ModuleSelection.vue'),
      meta: { roles: ['*'] }
    },
    // {
    //   path: '/',
    //   redirect: '/home'
    // },
    {
      name: 'Home',
      path: '/home',
      component: () => import('@/views/Home.vue'),
      redirect: '/home/cultural',
      meta: { roles: ['*'] },
      children: [
        // 文化基因
        {
          path: 'cultural',
          name: 'CulturalGene',
          redirect:'/home/cultural/ich',
          component: () => import('@/views/cultural/index.vue'),
          meta: { roles: ['admin', 'manager', 'user'] },
          children: [
            {
              path: 'ich',
              name: 'IntangibleHeritage',
              redirect:'/home/cultural/ich/heritor',
              component: () => import('@/views/cultural/ich/index.vue'),
              children: [
                { path: 'heritor', name: 'Heritor', component: () => import('@/views/cultural/ich/heritor/index.vue'),meta:{name: '非遗传承人'} },
                { path: 'project', name: 'Project', component: () => import('@/views/cultural/ich/project/index.vue'),meta:{name: '非遗项目'} },
                { path: 'base', name: 'Base', component: () => import('@/views/cultural/ich/base/index.vue'),meta:{name: '非遗项目'} },
                // { path: 'achievement', name: 'Achievement', component: () => import('@/views/cultural/ich/achievement/index.vue'),meta:{name: '非遗成果'} },
                // { path: 'innovation', name: 'Innovation', component: () => import('@/views/cultural/ich/innovation/index.vue'),meta:{name: '非遗创新'} },
                { path: 'news', name: 'News', component: () => import('@/views/cultural/ich/news/index.vue') ,meta:{name: '非遗资讯'}},
                // { path: 'updates', name: 'Updates', component: () => import('@/views/cultural/ich/updates/index.vue') ,meta:{name: '非遗动态'}},
                // { path: 'notices', name: 'Notices', component: () => import('@/views/cultural/ich/notices/index.vue') ,meta:{name: '非遗通知'}},
                { path: 'assessment', name: 'Assessment', component: () => import('@/views/cultural/ich/assessment/index.vue') ,meta:{name: '非遗考核'}},
                // { path: 'mall', name: 'Mall', component: () => import('@/views/cultural/ich/mall/index.vue') ,meta:{name: '非遗商城'}}
              ]
            },
            {
              path: 'tangible',
              name: 'TangibleHeritage',
              redirect: '/home/cultural/tangible/immovable',
              component: () => import('@/views/cultural/tangible/layout.vue'),
              children: [
                { path: 'immovable', name: 'TangibleImmovable', component: () => import('@/views/cultural/tangible/index.vue'), meta: { name: '不可动遗产' } },
                { path: 'village', name: 'TangibleVillage', component: () => import('@/views/cultural/tangible/village.vue'), meta: { name: '古村落遗产' } }
              ]
            },
            {
              path: 'youth',
              name: 'Youth',
              component: () => import('@/views/cultural/tangible/youth/index.vue'),
              meta: { name: '非遗新青年' }
            },
            {
              path: 'little-inheritor',
              name: 'LittleInheritor',
              component: () => import('@/views/cultural/tangible/little-inheritor/index.vue'),
              meta: { name: '小小传承人' }
            },
            {
              path: 'ecology',
              name: 'Ecology',
              component: () => import('@/views/cultural/ecology/index.vue')
            },
            {
              path: 'museums',
              name: 'Museums',
              component: () => import('@/views/cultural/museums/index.vue')
            },
            {
              path: 'relics',
              name: 'Relics',
              component: () => import('@/views/cultural/relics/index.vue')
            },
            {
              path: 'environment',
              name: 'Environment',
              component: () => import('@/views/cultural/environment/index.vue')
            },
            {
              path: 'documents',
              name: 'Documents',
              component: () => import('@/views/cultural/documents/index.vue')
            },
            {
              path: 'logs',
              name: 'Logs',
              component: () => import('@/views/cultural/logs/index.vue')
            },
            {
              path: 'api',
              name: 'Api',
              component: () => import('@/views/cultural/api/index.vue')
            }
          ]
        },

        // AI大脑
        {
          path: 'ai',
          name: 'AIBrain',
          component: () => import('@/views/ai/index.vue'),
          redirect: '/home/ai/analysis/monitoring',
          meta: { roles: ['admin', 'manager'] },
          children: [
            { path: 'collection', name: 'DataCollection', component: () => import('@/views/ai/collection/index.vue') },
            { path: 'monitor', name: 'RealtimeMonitor', component: () => import('@/views/ai/monitor/index.vue') },
            {
              path: 'analysis',
              name: 'DataAnalysis',
              component: () => import('@/views/ai/analysis/index.vue'),
              children: [
                { path: 'monitoring', name: 'InheritanceMonitoring', component: () => import('@/views/ai/analysis/monitoring/index.vue') },
                { path: 'training', name: 'TrainingAnalysis', component: () => import('@/views/ai/analysis/training/index.vue') },
                { path: 'activity', name: 'ActivityAnalysis', component: () => import('@/views/ai/analysis/activity/index.vue') },
                { path: 'vitality', name: 'VitalityAnalysis', component: () => import('@/views/ai/analysis/vitality/index.vue') },
                { path: 'personnel', name: 'PersonnelAnalysis', component: () => import('@/views/ai/analysis/personnel/index.vue') },
                { path: 'ecosystem', name: 'EcosystemAnalysis', component: () => import('@/views/ai/analysis/ecosystem/index.vue') },
                { path: 'qgzc', name: 'QgzcAnalysis', component: () => import('@/views/ai/analysis/qgzc/index.vue') },
                { path: 'cyyc', name: 'CyycAnalysis', component: () => import('@/views/ai/analysis/cyyc/index.vue') }
              ]
            },
            { path: 'risk', name: 'RiskWarning', component: () => import('@/views/ai/risk/index.vue') },
            { path: 'decision', name: 'DecisionModel', component: () => import('@/views/ai/decision/index.vue') },
            { path: 'management', name: 'IntelligentManagement', component: () => import('@/views/ai/management/index.vue') },
            { path: 'search', name: 'AISearch', component: () => import('@/views/service/heritor-search/index.vue') },
            { path: 'news-consultation', name: 'NewsConsultation', component: () => import('@/views/service/news-consultation/index.vue') }
          ]
        },

        // 服务管家
        {
          path: 'service',
          name: 'ServiceSteward',
          component: () => import('@/views/service/index.vue'),
          redirect: '/home/service/evaluation',
          meta: { roles: ['admin', 'manager'] },
          children: [
            // { path: 'audit', name: 'FillAudit', component: () => import('@/views/service/audit/index.vue') },
            { path: 'evaluation', name: 'EvaluationManage', component: () => import('@/views/service/evaluation/index.vue') },
            { path: 'assessment', name: 'Assessment', component: () => import('@/views/cultural/ich/assessment/index.vue') ,meta:{name: '非遗考核'}},

            { path: 'approval', name: 'ActivityApproval', component: () => import('@/views/service/approval/index.vue') },
            { path: 'notification', name: 'NotificationManage', component: () => import('@/views/service/notification/index.vue') },
            { path: 'news', name: 'News', component: () => import('@/views/cultural/ich/news/index.vue') ,meta:{name: '非遗资讯'}},
            // { path: 'updates', name: 'Updates', component: () => import('@/views/cultural/ich/updates/index.vue') ,meta:{name: '非遗动态'}},
            
            // { path: 'mall', name: 'Mall', component: () => import('@/views/cultural/ich/mall/index.vue') ,meta:{name: '非遗商城'}},
            { path: 'policy', name: 'PolicyRelease', component: () => import('@/views/service/policy/index.vue') },
            { path: 'reservation', name: 'ReservationManage', component: () => import('@/views/service/reservation/index.vue') },
            { path: 'guide', name: 'DeclarationGuide', component: () => import('@/views/service/guide/index.vue') },

            // 风险管理
            { path: 'risk-indicator', name: 'RiskIndicator', component: () => import('@/views/service/risk/indicator/index.vue') },
            { path: 'risk-warnings', name: 'RiskWarnings', component: () => import('@/views/service/risk/warnings/index.vue') },
            { path: 'risk-plans', name: 'RiskPlans', component: () => import('@/views/service/risk/plans/index.vue') },

            // 企业需求库
            { path: 'enterprise-needs', name: 'EnterpriseNeeds', component: () => import('@/views/service/enterprise/needs/index.vue') },

            // 信息采集管理
            { path: 'info-collection', name: 'InfoCollection', component: () => import('@/views/service/info-collection/index.vue') },

            // 建言献策
            { path: 'suggestions', name: 'Suggestions', component: () => import('@/views/service/suggestions/index.vue') },
            

            // 社区管理
            { path: 'community-category', name: 'CommunityCategory', component: () => import('@/views/service/community/category/index.vue') },
            { path: 'community-posts', name: 'CommunityPosts', component: () => import('@/views/service/community/posts/index.vue') },
            { path: 'community-comments', name: 'CommunityComments', component: () => import('@/views/service/community/comments/index.vue') },
            { path: 'community-users', name: 'CommunityUsers', component: () => import('@/views/service/community/users/index.vue') },

            // 积分与反馈
            { path: 'points', name: 'Points', component: () => import('@/views/service/points/index.vue') },
            { path: 'points-rule', name: 'PointsRule', component: () => import('@/views/service/points-rule/index.vue') },
            { path: 'feedback', name: 'FeedbackManage', component: () => import('@/views/service/feedback/index.vue') },
            { path: 'reservation', name: 'ReservationManage', component: () => import('@/views/service/reservation/index.vue') },
            { path: 'role-management', name: 'RoleManagement', component: () => import('@/views/service/role-management/index.vue') },
            { path: 'user-management', name: 'UserManagement', component: () => import('@/views/service/user-management/index.vue') },
            
            // 新增的管理页面
            { path: 'organization', name: 'OrganizationManage', component: () => import('@/views/service/organization/index.vue') },
            { path: 'approval-flow', name: 'ApprovalFlowManage', component: () => import('@/views/service/approval-flow/index.vue') },
            { path: 'audit-task', name: 'AuditTaskManage', component: () => import('@/views/service/audit-task/index.vue') },
            { path: 'audit-opinion', name: 'AuditOpinionManage', component: () => import('@/views/service/audit-opinion/index.vue') },
            { path: 'public-notice', name: 'PublicNoticeManage', component: () => import('@/views/service/public-notice/index.vue') }
          ]
        },

        // 生态引擎
        {
          path: 'ecosystem',
          name: 'EcologicalEngine',
          redirect: '/home/ecosystem/industry',
          component: () => import('@/views/ecosystem/index.vue'),
          meta: { roles: ['admin', 'manager', 'user'] },
          children: [
            { path: 'industry', name: 'EcoIndustry', component: () => import('@/views/ecosystem/industry/index.vue') },
            { path: 'education', name: 'EcoEducation', component: () => import('@/views/ecosystem/education/index.vue') },
            {
              path: 'tourism',
              name: 'EcoTourism',
              component: () => import('@/views/ecosystem/tourism/index.vue'),
              children: [
                { path: 'experience', name: 'HandicraftExperience', component: () => import('@/views/ecosystem/tourism/experience/index.vue') },
                { path: 'half-day', name: 'HalfDayTour', component: () => import('@/views/ecosystem/tourism/half-day/index.vue') },
                { path: 'one-day', name: 'OneDayTour', component: () => import('@/views/ecosystem/tourism/one-day/index.vue') },
                { path: 'three-day', name: 'ThreeDayTour', component: () => import('@/views/ecosystem/tourism/three-day/index.vue') },
                { path: 'ceramics', name: 'CeramicsStudy', component: () => import('@/views/ecosystem/tourism/ceramics/index.vue') },
                { path: 'visit', name: 'HeritorVisit', component: () => import('@/views/ecosystem/tourism/visit/index.vue') }
              ]
            },
            { path: 'technology', name: 'EcoTechnology', component: () => import('@/views/ecosystem/technology/index.vue') },
            { path: 'exchange', name: 'EcoExchange', component: () => import('@/views/ecosystem/exchange/index.vue') }
          ]
        }
      ]
    }
    
  ]
})

// 递归过滤路由
function filterAsyncRoutes(routes, store) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (tmp.path && tmp.path !== '/login') {
      if (hasPathPermission(tmp.path, store)) {
        if (tmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children, store);
        }
        res.push(tmp);
      }
    } else {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, store);
      }
      res.push(tmp);
    }
  });
  return res;
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 如果访问登录页，直接放行
  if (to.name === 'Login') {
    next();
    return;
  }
  
  // 检查是否已登录
  if (!store.getters['isAuthenticated']) {
    console.log("未登录")
    next({ name: 'Login', replace: true });
    return;
  }
  
  // 模块选择页只需要登录即可，不需要检查路径权限
  if (to.name === 'ModuleSelection' || to.path === '/module-selection') {
    next();
    return;
  }
  
  // 检查路径权限
  if (to.path && to.path !== '/login') {
    const allowedPaths = store.getters['allowedPaths'];
    
    if (!hasPathPermission(to.path, store)) {
      console.log("无权限访问路径:", to.path);
      
      // 避免无限循环：如果重定向到/home也没有权限，则重定向到第一个有权限的路径
      if (to.path === '/home' || from.path === '/home') {
        // 如果/home也没有权限，找到第一个有权限的路径
        const firstAllowedPath = allowedPaths && allowedPaths.length > 0 ? allowedPaths[0] : '/home';
        console.log("重定向到第一个有权限的路径:", firstAllowedPath);
        next({ path: firstAllowedPath, replace: true });
      } else {
        next({ path: '/home', replace: true });
      }
      return;
    }
  }
  
  next();
});
export default router;